var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tab-layout", {
    scopedSlots: _vm._u([
      {
        key: "title",
        fn: function() {
          return [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$l10n.__("Informations Générales")) +
                "\n    "
            )
          ]
        },
        proxy: true
      },
      {
        key: "content",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "well p-0 pb-3 flex-level flex-top ovx-auto" },
              [
                _c("section", { staticClass: "flex" }, [
                  _c("h3", { staticClass: "m-3 flex-row baseline" }, [
                    _vm._v(_vm._s(_vm.$l10n.__("L'opportunité")))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "px-3 br-1" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.removeEmptyValue(_vm.general), function(
                        item,
                        indexItem
                      ) {
                        return _c(
                          "li",
                          {
                            key: indexItem,
                            staticClass: "data-block data-block-hover"
                          },
                          [
                            _c(
                              item.format + "-data",
                              _vm._b(
                                { tag: "component" },
                                "component",
                                item,
                                false
                              )
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", { staticClass: "flex" }, [
                  _c("h3", { staticClass: "m-3 flex-row baseline" }, [
                    _c(
                      "span",
                      { staticClass: "flex-right" },
                      [
                        _c(
                          "link-button",
                          {
                            attrs: {
                              permissions: _vm.$store.getters.permissions,
                              "perm-to-check": "can_edit",
                              "data-bot": _vm.databot["generalinfoedit1"]
                            },
                            on: { clicked: _vm.editOpportunity }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Editer")) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "px-3" }, [
                    _c("h4", { staticClass: "m-0" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.isCorporation
                              ? _vm.$l10n.__("Société")
                              : _vm.$l10n.__("Particulier")
                          ) +
                          "\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.removeEmptyValue(_vm.third), function(
                        item,
                        indexItem
                      ) {
                        return _c(
                          "li",
                          {
                            key: indexItem,
                            staticClass: "data-block data-block-hover"
                          },
                          [
                            _c(
                              item.format + "-data",
                              _vm._b(
                                { tag: "component" },
                                "component",
                                item,
                                false
                              )
                            )
                          ],
                          1
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.isCorporation
                      ? _c(
                          "div",
                          _vm._l(_vm.linkedContacts, function(
                            contact,
                            contactIndex
                          ) {
                            return _c(
                              "div",
                              { key: contactIndex, staticClass: "mt-4" },
                              [
                                _c("h4", { staticClass: "m-0" }, [
                                  _vm._v(_vm._s(contact.name))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "ul",
                                  _vm._l(
                                    _vm.removeEmptyValue(contact.data),
                                    function(item, indexItem) {
                                      return _c(
                                        "li",
                                        {
                                          key: indexItem,
                                          staticClass:
                                            "data-block data-block-hover"
                                        },
                                        [
                                          _c(
                                            item.format + "-data",
                                            _vm._b(
                                              { tag: "component" },
                                              "component",
                                              item,
                                              false
                                            )
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("sellsy-informations-section", {
                  attrs: {
                    linkedid: _vm.$store.getters.linkedid,
                    linkedtype: _vm.$store.getters.linkedtype,
                    "enable-tags": true
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }